const constants = {
  LOCAL_STORAGE_KEYS: {
    TOKEN: 'auth_token',
    REFRESH_TOKEN: 'auth_refresh_token',
    THEME: 'sliceal-theme',
  },
  PORTAL_CODE: 'IN',
} as const

export default constants
